import json from '../package.json';

console.log(json.version);
